<template>
  <div class="single">
    <!-- “single”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></sirui-search>
    <div class="main-content">
      <vxe-grid
        border
        resizable
        align="left"
        size="mini"
        show-overflow
        ref="single"
        :auto-resize="true"
        :data="tableData"
        @cell-click="rowClick"
        :max-height="$store.state.app.tableHeight"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :width="item.width || 130"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title"
          :edit-render="item.editRender"
        >
        </vxe-table-column>
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  // import API from '@/api/productCenter/expenseDetail';
  import { mapState } from 'vuex';
  import SiruiSearch from '@/components/SiruiSearch';
  import tableMixins from '@/common/mixins/table.js';
  export default {
    name: 'singleList',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          //   策略编号
          {
            name: this.$t('futuresStrategy.futuresStrategyList.search.ptcombiNo'),
            prop: 'ptcombiNo',
            type: 'input',
            clearable: true,
          },
          //   业务部门
          {
            prop: 'departmentCode',
            name: this.$t('futuresStrategy.futuresStrategyList.search.departmentName'),
            type: 'select',
            placeholder: this.$t('futuresStrategy.futuresStrategyList.placeholder.departmentCode'),
            options: this.slipDepartmentList,
            clearable: true,
          },
          //策略名称
          {
            name: this.$t('futuresStrategy.futuresStrategyList.search.combiName'),
            prop: 'combiName',
            type: 'input',
            clearable: true,
          },
          //项目名称
          {
            name: this.$t('futuresStrategy.futuresStrategyList.search.projectName'),
            prop: 'projectName',
            type: 'input',
            clearable: true,
          },
        ];
      },
      columnListDefault() {
        return [
          //序号
          //{ type: "checkbox", visible: true, width: "50", fixed: "left" },
          { type: 'seq', visible: true, width: '50', fixed: 'left', title: this.$t('table.index') },
          //项目名称
          {
            field: 'projectName',
            title: this.$t('futuresStrategy.futuresStrategyList.table.projectName'),
            visible: true,
          },
          //策略编号
          {
            field: 'ptcombiNo',
            title: this.$t('futuresStrategy.futuresStrategyList.table.ptcombiNo'),
            visible: true,
          },
          //策略名称
          {
            field: 'combiName',
            title: this.$t('futuresStrategy.futuresStrategyList.table.combiName'),
            visible: true,
          },
          //交易日期
          {
            field: 'initDate',
            title: this.$t('futuresStrategy.futuresStrategyList.table.initDate'),
            visible: true,
            width: 80,
          },
          //业务部门
          {
            field: 'departmentName',
            title: this.$t('futuresStrategy.futuresStrategyList.table.departmentName'),
            visible: true,
            width: 120,
          },
          //合约代码
          {
            field: 'futuCode',
            title: this.$t('futuresStrategy.futuresStrategyList.table.futuCode'),
            visible: true,
          },
          //合约名称
          {
            field: 'stockName',
            title: this.$t('futuresStrategy.futuresStrategyList.table.stockName'),
            visible: true,
          },
          //币种
          {
            field: 'moneyType',
            title: this.$t('futuresStrategy.futuresStrategyList.table.moneyType'),
            visible: true,
          },
          //持仓方向
          {
            field: 'combiHoldType',
            title: this.$t('futuresStrategy.futuresStrategyList.table.combiHoldType'),
            visible: true,
          },
          //累计开仓均价
          {
            field: 'sumAverageOpenPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.sumAverageOpenPrice'),
            visible: true,
          },
          //累计开仓数量
          {
            field: 'sumOpenAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.sumOpenAmount'),
            visible: true,
          },

          //持仓均价
          {
            field: 'averageHoldPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.averageHoldPrice'),
            visible: true,
          },
          //持仓数量
          {
            field: 'currentAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.currentAmount'),
            visible: true,
          },
          //累计平仓均价
          {
            field: 'sumAverageDropPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.sumAverageDropPrice'),
            visible: true,
          },
        ];
      },
    },
    data() {
      return {
        loading: false,
        query: {
          ptcombiNo: null, //策略编号
          departmentCode: null, //业务部门
          combiName: null, //策略名称
          projectName: null, //项目名称
        },
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        }, //
        tableData: [], //列表数据
        heightNew: 0,
      };
    },
    mounted() {
      //this.getData();
      this.getButtonList();
      this.heightNew = document.body.clientHeight - 300 + 'px';
    },
    methods: {
      //获取table数据
      getData() {
        /* const params = JSON.parse(JSON.stringify(this.searchForm));
      params.pageSize = this.page.pageSize;
      params.pageNum = this.page.pageNum;
      this.load = true;
      this.$axios.post(API.SELECT_PLAN_BUSINESS_BYPAGE, params).then(res => {
        this.load = false;
        if (res.data.code === 0) {
          this.tableData = res.data.data.records;
          this.tableData.forEach(item => {
            item.companyDepartment = [
              item.planCompanyCode,
              item.planDepartmentCode
            ];
          });
          this.page.total = res.data.data.total;
        }
      }); */
      },
      searchBtnClick() {
        this.resetBtnClick();
      },
      resetBtnClick() {
        // 重置
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.multipleSelection = [];
        this.$refs.single.clearCheckboxReserve();
        this.getData();
      },
      //点击表格记录正在编辑哪一行
      rowClick(row) {
        this.$message({ showClose: true, type: 'info', message: row });
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
    },
  };
</script>
